import { useLive, useProject, useServices } from "../context";
import { Slider, ms, pct } from "./controls";
import { useSoundList } from "./SoundPicker";

/** Settings and credits for a track using a recorded instrument. */
export function SampledControls({ trackId }: { trackId: string }) {
  const { controller } = useServices();
  const inst = useProject((p) => p.tracks.find((t) => t.id === trackId)?.instrument);
  const status = useLive((s) => s.sounds[trackId]);
  const list = useSoundList();
  if (inst?.kind !== "multisample") return null;
  const info = list?.instruments.find((s) => s.id === inst.soundId);
  const source = info ? list?.sources[info.source] : undefined;
  const set = (patch: Partial<typeof inst.params>) => controller.updateProject((p) => ({
    ...p,
    tracks: p.tracks.map((t) => (t.id === trackId && t.instrument.kind === "multisample" ? { ...t, instrument: { ...t.instrument, params: { ...t.instrument.params, ...patch } } } : t)),
  }));
  return (
    <>
      {status?.status === "error" && status.soundId === inst.soundId && (
        <p className="status warn" role="alert">
          This sound could not load ({status.message}). <button type="button" onClick={() => void controller.retrySound(trackId)}>Retry</button>
        </p>
      )}
      <div className="controls-grid">
        <Slider label="Volume" value={inst.params.volume} min={0} max={1} format={pct} onChange={(volume) => set({ volume })} />
        {info?.type !== "drums" && (
          <Slider label="Release" value={inst.params.releaseSec} min={0.02} max={3} step={0.01} format={ms} onChange={(releaseSec) => set({ releaseSec })} hint="Fade time after the key is released" />
        )}
      </div>
      {info && source && (
        <p className="sound-credit">
          Recorded samples: {source.name} by {source.author}. Licence: {source.licence === "CC0-1.0" ? "CC0 1.0 (public domain dedication)" : source.licence}.{" "}
          <a href={source.url} target="_blank" rel="noopener noreferrer">Source</a>
        </p>
      )}
    </>
  );
}
